import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";
import moment from "moment";
import "./MessageThread.css";

const MessageThread = ({ show, handleClose, onSend, status, messages }) => {
  const [newMessage, setNewMessage] = useState("");
  const bottomRef = useRef(null);
  const [activeTab, setActiveTab] = useState("messages");
  let docCount = 1;

  useEffect(() => {
    if (activeTab === "messages" && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, activeTab]);

  const handleSend = () => {
    const trimmed = newMessage.trim();
    if (trimmed) {
      onSend(trimmed);
      setNewMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const renderMessage = (msg, index) => {
    const isAgent = msg.senderType === "agent";
    return (
      <div
        key={msg._id || index}
        className={`message-bubble ${
          isAgent ? "agent-message" : "user-message"
        }`}
      >
        <div className="message-meta">
          {isAgent ? "Agent" : "User"} •{" "}
          {moment(msg.sentAt).format("MMM D, h:mm A")}
        </div>
        <div className="message-text">{msg.message}</div>
        {msg.files?.length > 0 && (
          <div className="message-files">
            {msg.files.map((file, i) => (
              <a key={i} href={file} target="_blank" rel="noopener noreferrer">
                📎 Document {docCount++}
              </a>
            ))}
          </div>
        )}
      </div>
    );
  };

  const allFiles = messages.flatMap(
    (msg) =>
      msg.files?.map((file) => ({
        file,
        sender: msg.senderType,
        date: msg.sentAt,
        message: msg.message,
      })) || []
  );

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Verification</Modal.Title>
      </Modal.Header>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="px-4 pt-2"
      >
        <Tab eventKey="messages" title="Messages" />
        <Tab eventKey="documents" title="Uploaded Documents" />
      </Tabs>

      <Modal.Body className="message-body">
        {activeTab === "messages" ? (
          messages.length === 0 ? (
            <p className="text-center text-muted">No messages yet.</p>
          ) : (
            <>
              {messages.map(renderMessage)}
              <div ref={bottomRef} />
            </>
          )
        ) : allFiles.length === 0 ? (
          <p className="text-center text-muted">No documents uploaded yet.</p>
        ) : (
          <ul className="list-group">
            {allFiles.map((doc, index) => (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={index}
              >
                <div>
                  <strong>{doc.sender.toUpperCase()}</strong> •{" "}
                  {moment(doc.date).format("MMM D, h:mm A")}
                  <br />
                  <small className="text-muted">{doc.message}</small>
                </div>
                <a
                  href={doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-primary"
                >
                  View
                </a>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>

      {(activeTab === "messages" && status) && (
        <Modal.Footer className="message-footer">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Type your message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <Button
            variant="primary"
            onClick={handleSend}
            disabled={!newMessage.trim()}
          >
            Send
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default MessageThread;
